import { ComponentProps } from 'react';
import { Box } from '@qga/roo-ui/components';

import Alert from '@/components/Alert';
import Text from '@/components/Text';
import { useRoomOptionsData } from '@/v2/components/pages/PackageViewV2/contexts/RoomOptionsContext';
import { useCampaign } from '@/v2/contexts/campaign';

interface CampaignInfoProps extends ComponentProps<typeof Box> {}

const CampaignInfo = (props: CampaignInfoProps) => {
  const { isCampaignAvailable } = useRoomOptionsData() || {};
  const campaign = useCampaign();
  const title = campaign?.sashing?.flightPillText;

  if (!title || !isCampaignAvailable) return null;

  const heading = `${title} flights`;
  const body = `This package includes one or more ${title} sale flights. You can change your flights selection next.`;

  return (
    <Box {...props}>
      <Alert.Info
        icon={{ name: 'info', color: 'brand.secondary' }}
        mb="0"
        data-testid="CAMPAIGN_INFO"
      >
        <Box ml="1">
          <Text
            fontSize="xs"
            lineHeight="20px"
            letterSpacing="0.1px"
            color="text.heading"
            bold
          >
            {heading}
          </Text>
          <Box>
            <Text
              fontSize="xs"
              lineHeight="20px"
              letterSpacing="0.1px"
              color="text.heading"
            >
              {body}
            </Text>
          </Box>
        </Box>
      </Alert.Info>
    </Box>
  );
};

export default CampaignInfo;
